/**
 * Validates that a required variant prop is provided.
 * Logs a warning in development if missing or invalid.
 * 
 * @param componentName - Name of the component (for error message)
 * @param variant - The variant value passed to the component
 * @param validVariants - Object containing valid variant values (e.g., PRICE_VARIANTS)
 * @returns true if valid, false if invalid
 */
export function validateVariant<T extends Record<string, string>>(
  componentName: string,
  variant: string | undefined,
  validVariants: T
): variant is T[keyof T] {
  const values = Object.values(validVariants);
  
  if (!variant || !values.includes(variant)) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(
        `[${componentName}] Missing or invalid variant: "${variant}". Expected one of: ${values.join(', ')}`
      );
    }
    return false;
  }
  
  return true;
}
